import { ITimeSlotsDetails } from "@/api/AppApi/services/time-slots/interfaces/api-time-slots-interfces";
import AvailableSlots from "./day-appointments-helpers/AvailableSlots";
import NoSlotsAvailable from "./day-appointments-helpers/NoSlotsAvailable";
import LessMore from "@/app/components/lib/LessMore";
import { FieldValues, UseFormReturn } from "react-hook-form";
import { ICommonProductDetails } from "@/api/AppApi/services/product/interfaces/api-product-details-interface";
import { useState } from "react";
import AgreeTermsCheckbox from "@/app/components/pages-components/common/agree-terms/AgreeTermsCheckbox";
import { IuseProductHasAttrsResult } from "@/hooks/product-has-attrs/product-has-attrs-helpers/interfaces";

interface Props {
  slotsDetails?: ITimeSlotsDetails;
  beside: boolean;
  product: ICommonProductDetails;
  form: UseFormReturn<FieldValues, any>;
  productState?: IuseProductHasAttrsResult
}

const DayAppointments: React.FC<Props> = ({
  slotsDetails,
  beside,
  product,
  form,
  productState,
}) => {
  const termAndCondition = product?.custom_data?.term_and_condition;
  const redirectToCheckout = product?.custom_data?.redirect_to_checkout;
  const [agree, setAgree] = useState(!!!termAndCondition);
  return (
    <>
      <div className="appointments-description">
        {slotsDetails?.long_description && (
          <LessMore
            text={slotsDetails?.description}
            limit={50}
            className=""
            moreClassName="see-more"
          />
        )}
        {termAndCondition && (
          <AgreeTermsCheckbox
            checked={agree}
            setChecked={setAgree}
            terms={termAndCondition}
            primaryInnerColor
          />
        )}
      </div>
      
      {slotsDetails?.slots.length === 0 ? (
        <NoSlotsAvailable />
      ) : (
        <AvailableSlots
          productState={productState}
          agreeTerms={agree}
          redirectToCheckout={redirectToCheckout!}
          beside={beside}
          slots={slotsDetails?.slots}
          form={form}
          productId={product.id}
        />
      )}
    </>
  );
};

export default DayAppointments;
